// troubleTips — 「困りごとのコツ」(困っている状況を検出して 1 回だけ出す小さなカード) の
// 純粋ロジック。docs/_wip/aa-default-and-trouble-tips-2026-10-27.md §2。
//
// 「コツ 1 件 = id + 条件 + 中身」の形だけ用意する (初版は AA の 1 件のみ。汎用基盤は作らない)。
// 中身 (文言・画像) は presentation の TroubleTipCard、既読は infrastructure/tipSeen.ts。

import type { StrokePen, TroubleTipId } from '@oekaki/protocol';

export interface TroubleTipStroke {
  /** 描き終えた線のペン種 (ペン尻の消しゴム化後の実効値)。 */
  readonly pen: StrokePen;
  readonly width: number;
  /** 描き終えた時点の表示倍率 (engine の zoom)。 */
  readonly zoom: number;
}

export interface TroubleTip {
  readonly id: TroubleTipId;
  /** 条件を満たしたこのストロークを数える。 */
  readonly counts: (ctx: {
    /** 自分で選んだ AA 値 (未設定 = null)。 */
    readonly aaExplicit: boolean | null;
    /** 実際の AA 値 (自分で選んだ値 → 端末の既定 → off の解決後)。 */
    readonly aaEffective: boolean;
    readonly stroke: TroubleTipStroke;
  }) => boolean;
  /** 条件を満たしたストロークがこの本数に達したら出す。 */
  readonly strokesNeeded: number;
}

/** AA カード: 自分で選んだ値なし かつ 実際の AA がなし × 細い線 (3px 以下) × 拡大 (1.5 倍以上) で 5 本。 */
export const AA_SMOOTH_TIP: TroubleTip = {
  id: 'aa-smooth',
  strokesNeeded: 5,
  counts: ({ aaExplicit, aaEffective, stroke }) =>
    aaExplicit === null &&
    !aaEffective &&
    stroke.pen !== 'eraser' &&
    stroke.width <= 3 &&
    stroke.zoom >= 1.5,
};

/**
 * カード内のボタン / リンクの click を受理してよいか。
 * タッチの互換 click はディスパッチ時に再ヒットテストされるため、ペンアップ直後に出たカードへ
 * 「カードの外で始まったタッチ」の click が着弾しうる (oekaki/CLAUDE.md「タッチの
 * ゴーストクリック」)。カード内で pointerdown が始まった click (armed) だけ通す。
 * キーボード由来の click は `detail === 0` で常に通す。
 */
export const shouldAcceptCardClick = (armed: boolean, detail: number): boolean =>
  detail === 0 || armed;
